/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'

export default class LimitationField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props
    const options = [{ key: 1, text: 'Limit', value: 'limit' }, { key: 2, text: 'Unlimit', value: 'unlimit' }]

    return (
      <Form.Select
        fluid
        label="Limitation"
        options={options}
        placeholder="Limit or Unlimit"
        onChange={(e, data) => onChange(data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/specialDeal/fields/LimitationField.js